import { DOCUMENT } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'empty-layout',
    templateUrl: './empty.component.html',
    styleUrl: './empty.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [RouterOutlet],
})
export class EmptyLayoutComponent implements OnInit, OnDestroy {
    private readonly _document = inject(DOCUMENT);

    ngOnInit(): void {
        this._document.documentElement.classList.add('competencies-embed');
    }

    ngOnDestroy(): void {
        this._document.documentElement.classList.remove('competencies-embed');
    }
}
